import { useState } from "react";
import "./ContactPage.css";

function ContactPage() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    website: "", // Honeypot field
  });
  const [status, setStatus] = useState({ type: "", message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ type: "", message: "" });

    try {
      const response = await fetch("/contact-form.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: new URLSearchParams(formData),
      });

      const data = await response.json();

      if (response.ok) {
        setStatus({
          type: "success",
          message: "Nachricht wurde erfolgreich gesendet!",
        });
        setFormData({ name: "", email: "", message: "", website: "" });
      } else {
        setStatus({
          type: "error",
          message: data.error || "Ein Fehler ist aufgetreten.",
        });
      }
    } catch (error) {
      setStatus({
        type: "error",
        message:
          "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <h1>Kontakt</h1>
      <p>
        Ich kann zur Zeit keine Ausbildungs- oder Praktikumsplätze anbieten.
      </p>

      <p>Füllen Sie das Formular aus, um mich zu kontaktieren.</p>

      {status.message && (
        <div className={`status-message ${status.type}`}>{status.message}</div>
      )}

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Nachricht</label>
          <textarea
            id="message"
            name="message"
            value={formData.message}
            onChange={handleChange}
            required
            minLength="10"
          />
        </div>

        {/* Honeypot field - hidden from users but visible to bots */}
        <div className="form-group" style={{ display: "none" }}>
          <label htmlFor="website">Website</label>
          <input
            type="text"
            id="website"
            name="website"
            value={formData.website}
            onChange={handleChange}
          />
        </div>

        <button type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Wird gesendet..." : "Nachricht senden"}
        </button>
      </form>
    </div>
  );
}

export default ContactPage;
